// These types is used as class for buttons.
export enum ButtonColorType {
    PRIMARY = 'primary',
    SECONDARY = 'secondary',
    WARN = 'warn',
    SUCCESS = 'success',
    INFO = 'info',
    DEFAULT = 'default'
}
